module.exports = __webpack_public_path__ + "media/Little Big Us.83701f69.mp3";